const STRING = Symbol('string');
const DATE = Symbol('date');
const ARRAY = Symbol('array');

export {
  STRING,
  DATE,
  ARRAY,
};
